class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.initializeEventListeners();
    this.setupCartUpdates();
  }

  initializeEventListeners() {
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setupCartUpdates() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      console.log('Cart update:', event.source);
      
      this.updateCartBubble();
      
      if (event.source === 'product-form') {
        this.refreshAndOpen();
      }
    });

    this.interceptCartChanges();
  }

  interceptCartChanges() {
    const originalFetch = window.fetch;
    
    window.fetch = (...args) => {
      const [url] = args;
      
      if (typeof url === 'string' && url.includes('/cart/change')) {
        return originalFetch(...args).then(response => {
          setTimeout(() => {
            this.updateCartBubble();
            this.formatAllPrices();
          }, 300);
          return response;
        });
      }
      
      return originalFetch(...args);
    };
  }

  async refreshAndOpen() {
    try {
      const response = await fetch(`${window.location.pathname}?section_id=cart-drawer`);
      const text = await response.text();
      const html = new DOMParser().parseFromString(text, 'text/html');

      const newCartDrawer = html.querySelector('cart-drawer');
      const newDrawerInner = html.querySelector('.drawer__inner');

      if (newCartDrawer && newDrawerInner) {
        this.className = newCartDrawer.className;

        const currentDrawerInner = this.querySelector('.drawer__inner');
        if (currentDrawerInner) {
          currentDrawerInner.innerHTML = newDrawerInner.innerHTML;

          setTimeout(() => this.formatAllPrices(), 50);
        }
      }

      const newModal = html.querySelector('.subscription-modal');
      const currentModal = this.querySelector('.subscription-modal');

      if (newModal && !currentModal) {
        this.appendChild(newModal.cloneNode(true));
      } else if (!newModal && currentModal) {
        currentModal.remove();
      } else if (newModal && currentModal) {
        currentModal.replaceWith(newModal.cloneNode(true));
      }

      setTimeout(() => {
        this.setupDrawerControls();
        this.setupSubscriptionModal();
        this.open();
      }, 100);

    } catch (error) {
      console.error('Error refreshing cart drawer:', error);
      this.open();
    }
  }

  setupDrawerControls() {
    this.querySelector('#CartDrawer-Overlay')?.addEventListener('click', this.close.bind(this));
    this.querySelector('.drawer__close')?.addEventListener('click', this.close.bind(this));
  }

  setupSubscriptionModal() {
    const showButton = this.querySelector('#show-subscription-modal');
    const modal = this.querySelector('#subscription-modal');

    if (!showButton || !modal) return;

    const closeButton = modal.querySelector('.modal-close');
    const overlay = modal.querySelector('.subscription-modal-overlay');

    const closeModal = () => {
      console.log('🚪 Closing modal');
      modal.classList.remove('show');
      document.body.classList.remove('modal-open');
    };

    const openModal = () => {
      console.log('🎉 Opening modal');
      modal.classList.add('show');
      document.body.classList.add('modal-open');
    };

    const newShowButton = showButton.cloneNode(true);
    showButton.parentNode.replaceChild(newShowButton, showButton);

    newShowButton.addEventListener('click', function(e) {
      e.preventDefault();
      openModal();
    });

    if (closeButton) {
      closeButton.addEventListener('click', function(e) {
        e.preventDefault();
        closeModal();
      });
    }

    if (overlay) {
      overlay.addEventListener('click', function(e) {
        e.preventDefault();
        closeModal();
      });
    }

    if (!this.escapeListenerAdded) {
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && modal.classList.contains('show')) {
          closeModal();
        }
      });
      this.escapeListenerAdded = true;
    }

  }

  formatAllPrices() {
    console.log('🎨 Formatting prices...');

    this.querySelectorAll('[data-price]').forEach(element => {
      const price = element.getAttribute('data-base-price');
      if (price) {
        const formattedPrice = this.formatMoney(parseInt(price));
        const priceElement = element.querySelector('.price') || element;
        priceElement.textContent = formattedPrice;
      }
    });

    this.updateSubtotal();

    console.log('✅ Prices formatted');
  }

  formatMoney(cents) {
    if (cents === null || cents === undefined) return '';

    const amount = Math.abs(cents / 100);
    const formattedAmount = amount.toFixed(2);
    const parts = formattedAmount.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return `$${parts.join('.')}`;
  }

  async updateSubtotal() {
    try {
      const response = await fetch('/cart.js');
      const cartData = await response.json();

      const subtotalElement = this.querySelector('.totals__total-value');
      if (subtotalElement) {
        subtotalElement.textContent = this.formatMoney(cartData.total_price);
      }
    } catch (error) {
      console.error('Error updating subtotal:', error);
    }
  }

  async updateCartBubble() {
    try {
      const response = await fetch('/cart.js');
      const cartData = await response.json();

      const cartIcon = document.querySelector('#cart-icon-bubble');
      const cartBubble = cartIcon?.querySelector('.cart-count-bubble');

      if (!cartIcon) return;

      if (cartData.item_count > 0) {
        if (!cartBubble) {
          const newBubble = document.createElement('div');
          newBubble.className = 'cart-count-bubble';
          newBubble.innerHTML = `
            <span aria-hidden="true">${cartData.item_count}</span>
            <span class="visually-hidden">${cartData.item_count} items in cart</span>
          `;
          cartIcon.appendChild(newBubble);
        } else {
          const span = cartBubble.querySelector('span[aria-hidden="true"]');
          const hidden = cartBubble.querySelector('.visually-hidden');

          if (span) span.textContent = cartData.item_count;
          if (hidden) hidden.textContent = `${cartData.item_count} items in cart`;
        }
      } else {
        cartBubble?.remove();
      }

      console.log('✅ Header updated:', cartData.item_count);

    } catch (error) {
      console.error('Error updating cart bubble:', error);
    }
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) {
      this.setSummaryAccessibility(cartDrawerNote);
    }
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty')
        ? this.querySelector('.drawer__inner-empty')
        : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');

    const modal = this.querySelector('#subscription-modal');
    if (modal && modal.classList.contains('show')) {
      modal.classList.remove('show');
      document.body.classList.remove('modal-open');
    }
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
  connectedCallback() {
    setTimeout(() => {
      this.formatAllPrices();
      this.setupSubscriptionModal();
    }, 100);
  }
  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
